const despesa = (DataBase, Datatype) => {
	const Despesa = DataBase.new(
		{
			id_fornecedor: Datatype.STRING,
			id_forma_pagamento: Datatype.STRING,
			c_nfe: Datatype.STRING,
			status: Datatype.BOOLEAN,
			valor: Datatype.NUMBER,
			valor_pago: Datatype.NUMBER,
			dt_pagamento: Datatype.TIMESTAMP,
			dt_vencimento: Datatype.TIMESTAMP,
			descricao: Datatype.STRING,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "despesa",
			model: "Despesa",
		}
	);

	Despesa.relate = (models) => [
		{
			model: models.Fornecedor,
			fk: "id_fornecedor",
			name: "fornecedor",
		},
		{
			model: models.FormaPagamento,
			fk: "id_forma_pagamento",
			name: "forma_pagamento",
		},
	];

	return Despesa;
};

export default despesa;
